import { api } from '@/api';

export default {
  namespaced: true,
  state: {
    crmPresets: [],
    serviceStyles: [],
    qualityOptions: {},
    loading: false,
    history: [],
  },
  mutations: {
    SET_CRM_PRESETS(state, presets) {
      state.crmPresets = presets;
    },
    SET_SERVICE_STYLES(state, styles) {
      state.serviceStyles = styles;
    },
    SET_QUALITY_OPTIONS(state, options) {
      state.qualityOptions = options;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_HISTORY(state, history) {
      state.history = history;
    },
  },
  actions: {
    async fetchPlanBatchFormData({ commit }) {
      commit('SET_LOADING', true);
      try {
        const response = await api.getPlanBatchFormData();
        commit('SET_CRM_PRESETS', response.data.crm_presets || []);
        commit('SET_SERVICE_STYLES', response.data.service_styles || []);
        commit('SET_QUALITY_OPTIONS', response.data.quality_options || {});
        return response;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async executePlanBatchAction({ commit }, formData) {
      commit('SET_LOADING', true);
      try {
        const response = await api.executePlanBatchAction(formData);
        return response;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async checkPlanBatchStatus({ commit }, logId) {
      const response = await api.checkPlanBatchStatus(logId);
      return response;
    },

    async loadPlanBatchHistory({ commit }, searchQuery = '') {
      const params = searchQuery ? { search: searchQuery } : {};
      const response = await api.loadPlanBatchHistory(params);
      commit('SET_HISTORY', response.data || []);
      return response;
    },

    async getPlanBatchLogDetails({ commit }, logId) {
      const response = await api.getPlanBatchLogDetails(logId);
      return response;
    },

    async fetchPlanBatchSendPreview({ commit }, planInputs) {
      const response = await api.getPlanBatchSendPreview(planInputs);
      return response;
    },
  },
  getters: {
    isLoading: (state) => state.loading,
    getCrmPresets: (state) => state.crmPresets,
    getServiceStyles: (state) => state.serviceStyles,
    getQualityOptions: (state) => state.qualityOptions,
    getHistory: (state) => state.history,
  },
};
